import { __assign, __rest } from "tslib";
import React, { useRef, useContext, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import ddt from '@wix/da-ddt';
import { isActiveThread, updateCommentOffset } from '../../helpers';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleThread from '../SimpleThread';
import OffsetTrackingComment from '../../_partials/OffsetTrackingComment';
var logger = ddt.createLogger('comments');
var resetCommentOffset = function () { return updateCommentOffset(); };
var OffsetTrackingCommentThread = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var threadStartRef = useRef(null);
    var isMobile = useContext(MobileContext);
    useEffect(function () {
        var threadStart = threadStartRef.current;
        if (isActiveThread(props.commentableTypeId, props.commentableItemId) &&
            threadStart) {
            logger.log('Scrolling to active thread');
            scrollIntoViewWithHeader(threadStart, isMobile);
        }
    }, [isMobile, props.commentableTypeId, props.commentableItemId]);
    return (React.createElement(Waypoint, { onLeave: resetCommentOffset },
        React.createElement("div", { className: className, ref: threadStartRef },
            React.createElement(SimpleThread, __assign({}, props, { commentComponent: OffsetTrackingComment })))));
};
OffsetTrackingCommentThread.displayName = 'OffsetTrackingCommentThread';
export default OffsetTrackingCommentThread;
//# sourceMappingURL=OffsetTrackingCommentThread.js.map